import { Box } from 'grommet'
import styled, { css } from 'styled-components'

import LargeTriangle from '@public/images/animated-icons/large-triangle.svg'
import TriangleSmall from '@public/images/animated-icons/triangle-small.svg'
import Triangle from '@public/images/animated-icons/triangle.svg'

export const BottomCatchTriangle = styled(Triangle)`
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
  transition: 0.3s all ease;
`

export const BottomCatchTriangleOrange = styled(Triangle)`
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
  transition: 0.3s all ease;
  path {
    fill: ${({ theme }) => theme.newColors.orange};
  }
`

export const LeftSideTriangle = styled(TriangleSmall)`
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
  transition: 0.3s all ease;
`

export const TriangleSmallOrange = styled(TriangleSmall)`
  transition: 0.3s all ease;
  path {
    fill: ${({ theme }) => theme.newColors.orange};
  }
`

export const LeftSideTriangleOrange = styled(TriangleSmall)`
  -webkit-transform: rotate(270deg);
  transform: rotate(270deg);
  transition: 0.3s all ease;
  path {
    fill: ${({ theme }) => theme.newColors.orange};
  }
`

export const TopTriangle = styled(Triangle)`
  transition: 0.3s all ease;
  path {
    fill: ${({ theme }) => theme.newColors.orange};
  }
`

export const LargeTriangleOrange = styled(LargeTriangle)`
  path {
    fill: ${({ theme }) => theme.newColors.orange};
  }
`

export const AdvantagesSectionWrapper = styled(Box)`
  margin: ${({ theme }) => theme.newSpaces.xl5}px 0;
  overflow: hidden;
  transition: 0.3s all ease;

  ${({ theme }) => css`
    ${theme.below.tablet`
      margin: ${({ theme }) => theme.newSpaces.xl5}px 0;
    `}
  `}
`
